import axios from 'axios';

export interface receptionProps {
    loginId: string,
    eventJoinId: string,
    rotaryCd: string
}

/**
 * イベント受付　受付をするAPIを呼び出す関数
 */
export async function setReception(props: receptionProps): Promise<any> {
    try {
        const response = await axios.put(process.env.REACT_APP_PATH + `/users/me/event/checkin`, null, {
            params: {
                loginId: props.loginId,
                eventJoinId: props.eventJoinId,
                rotaryCd: props.rotaryCd
            },
            paramsSerializer: {
                indexes: null
            }
        });

        return response;

    } catch (err) {
        console.error(err);
    }
}